/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkEditRequestBulkEdit } from './BulkEditRequestBulkEdit';
import {
    BulkEditRequestBulkEditFromJSON,
    BulkEditRequestBulkEditFromJSONTyped,
    BulkEditRequestBulkEditToJSON,
} from './BulkEditRequestBulkEdit';

/**
 * 
 * @export
 * @interface BulkEditRequest
 */
export interface BulkEditRequest {
    /**
     * 
     * @type {BulkEditRequestBulkEdit}
     * @memberof BulkEditRequest
     */
    bulkEdit: BulkEditRequestBulkEdit;
    /**
     * ISO-8601 timestamp of when the change was initiated (advisory)
     * @type {string}
     * @memberof BulkEditRequest
     */
    eventTime?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequest
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequest
     */
    westburyId?: string;
}

/**
 * Check if a given object implements the BulkEditRequest interface.
 */
export function instanceOfBulkEditRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bulkEdit" in value;

    return isInstance;
}

export function BulkEditRequestFromJSON(json: any): BulkEditRequest {
    return BulkEditRequestFromJSONTyped(json, false);
}

export function BulkEditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bulkEdit': BulkEditRequestBulkEditFromJSON(json['bulk_edit']),
        'eventTime': !exists(json, 'event_time') ? undefined : json['event_time'],
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
        'westburyId': !exists(json, 'westbury_id') ? undefined : json['westbury_id'],
    };
}

export function BulkEditRequestToJSON(value?: BulkEditRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bulk_edit': BulkEditRequestBulkEditToJSON(value.bulkEdit),
        'event_time': value.eventTime,
        'user_id': value.userId,
        'westbury_id': value.westburyId,
    };
}

